import type { RouteRecordRaw } from 'vue-router'

// 路由元信息类型
export interface RouteMeta {
  titleKey?: string
  keepAlive?: boolean
  requiresAuth?: boolean
  roles?: string[]
}

// 扩展路由记录类型
export interface AppRouteRecordRaw extends Omit<RouteRecordRaw, 'meta' | 'children'> {
  meta?: RouteMeta
  children?: AppRouteRecordRaw[]
}

// 路由名称常量
export const ROUTE_NAMES = {
  // 主页
  HOME: 'home',
  
  // 用户相关
  USER_PROFILE: 'user-profile',
  USER_POSTER: 'user-poster',
  
  // 卡组相关
  DECK_POSTER: 'deck-poster',
  DECK_SHARE: 'deck-share',
  
  // 卡牌相关
  CARD_ALBUM: 'card-album',
  CARD_ALBUM_POSTER: 'card-album-poster',
  CARD_POSTER: 'card-poster',
  CARD_DETAIL: 'card-detail',
  
  // 卡包相关
  PACK_SHARE: 'pack-share',
  PACK_POSTER: 'pack-poster',
  
  // 商店相关
  SHOP: 'shop',
  SHOP_POSTER: 'shop-poster',
  
  // 心愿单相关
  WISH: 'wish',
  WISH_POSTER: 'wish-poster',
  
  // 动态相关
  DYNAMIC_SHARE: 'dynamic-share',
  DYNAMIC_POSTER: 'dynamic-poster',
  
  // AI新闻相关
  AI_NEWS: 'ai-news',
  AI_NEWS_POSTER: 'ai-news-poster',
  
  // AI卡组相关
  AI_DECK: 'ai-deck',
  AI_DECK_POSTER: 'ai-deck-poster',
  
  // 拍卖相关
  AUCTION_SHARE: 'auction-share',
  AUCTION_POSTER: 'auction-poster',
  
  // 活动相关
  ACTIVITY: 'activity',
  ACTIVITY_POSTER: 'activity-poster',
  ACTIVITY_RULES: 'activity-rules',
  ACTIVITY_INVITE: 'activity-invite',
  ACTIVITY_SIGNUP: 'activity-signup',
  ACTIVITY_WORK_DETAIL: 'activity-work-detail',
  ACTIVITY_RANK_RECORD: 'activity-rank-record',
  ACTIVITY_LOTTERY: 'activity-lottery',
  ACTIVITY_CENTER: 'activity-center',
  ACTIVITY_PRIZE_LIST: 'activity-prize-list',
  ACTIVITY_LOTTERY_POSTER: 'activity-lottery-poster',
  ACTIVITY_EXCHANGE_COUPON: 'activity-exchange-coupon',
  
  // 其他
  SEARCH_RANKING: 'search-ranking',
  ADD_BANK_CARD: 'add-bank-card',
  SPECIAL_LAW: 'special-law',
  AI_SCAN_INTRODUCE: 'ai-scan-introduce',
  
  // 404
  NOT_FOUND: 'not-found',
} as const

// 路由名称类型
export type RouteName = typeof ROUTE_NAMES[keyof typeof ROUTE_NAMES] 